export const EVALUATION_DECISION_METRICS = [
  'labelMatchRate',
  'successRate',
] as const;

export type EvaluationDecisionMetric =
  (typeof EVALUATION_DECISION_METRICS)[number];
